import React from 'react';

import styled, { css } from 'styled-components';
import { StyledTypography } from 'styles/common';

import { EMPTY_GROUP_TEXT } from 'constants/ProjectConstants';

import { StyledTableRow, StyledTableCell } from './styles';

const TaskHeadingRow = ({ text, orderBy }) => (
  <StyledTableRow>
    <StyledTableCell2 colSpan={8}>
      <StyledTypography display="inline" weight={600}>
        {orderBy === 'TAGS' && text && text != EMPTY_GROUP_TEXT ? (
          <span>#{text}</span>
        ) : (
          <StyledSpan empty={text === EMPTY_GROUP_TEXT}>{text}</StyledSpan>
        )}
      </StyledTypography>
    </StyledTableCell2>
  </StyledTableRow>
);

const StyledTableCell2 = styled(StyledTableCell)`
  padding: 1rem 1rem;
  font-size: 18px;
  background: #fafafa;
  border-bottom: 1px solid #e0edfe;
`;

const StyledSpan = styled.span`
  ${(props) =>
    props.empty &&
    css`
      font-weight: 400;
      opacity: 0.75;
    `};
    }
`;

export default TaskHeadingRow;
